export const RongYunKeys = {
  // 暂时不能改变ryUuid这个值，当前代码在重构中，为了渐进兼容之前的代码
  // 存储游客加入融云信息{rongYunUserId, token, name: "游客"}
  RONGYUN_USER_INFO: "ryUuid"
};

export const RongYunChatRoomJoinStatus = {
  // 加入聊天室状态
  OFF: 0, // 离线
  ERROR: 1, // 错误
  ON: 2 // 加入成功
};

export const RongYunConnectStatus = {
  // 融云连接状态
  ERROR: -1,
  CONNECTED: 0, // 链接成功
  CONNECTING: 1, // 正在连接中
  DISCONNECTED: 2, // 用户主动断开链接
  NETWORK_UNAVAILABLE: 3, // 网络不可用, SDK 内部会自动重连
  SOCKET_ERROR: 4, // Socket 不可用, SDK 内部会自动重连
  KICKED_OFFLINE_BY_OTHER_CLIENT: 6, // 被其他端踢掉
  BLOCKED: 12, // 用户被封禁
  SUSPEND: 13
};

export const MessageTypes = {
  //常量命名貌似别使用":"等内建字符
  HB: "TG:HBMsg", // 红包
  JOIN_CHATROOM: "TG:LotteryWelcomeJoinMessage", // 通知其它端口哪个用户加入了聊天室
  WELCOME: "TG:LotteryTipsForSelfMessage", // 本地欢迎
  CLEAR_CHATROOM_MSG: "TG:ClearMessage", // 聊天室清屏
  FOLLOW_ORDER: "TG:BettingMsg", // 跟单
  Emoji: "TG:LotteryEmojiMessage", // 自定义的GIF表情
  FOLLOW_LOTTERY: "TG:BetplanBotMsg", // 一键跟投
  LOTTERY: "TG:LotteryMsg", // 开奖
  SHARE_BET_WIN: "TG:ShareBetWin", // 注单详情-晒单 分享今日收益
  SHARE_BET_MSG: "TG:ShareBetMsg", // 用户手动分享注单
  RED_PACKET_BATTLE: "TG:HbdzMsg", // 红包大战
  NN_HB_COUNT_MSG: "TG:HbnnjsMsg" // 牛牛红包结算通知
};

export const PushTypes = {
  // 自定义与后台推送来的消息
  KEEP_ALIVE: "00", //00 保活服务 ?????????????
  LOTTERY: "01", // 新的开奖
  SYSTEM_NOTICE: "02", // 系统公告
  SPECIAL_OFFERS: "03", // 优惠活动
  LOTTERY_ORDER: "04", // 中奖注单
  USER_BALANCE_CHANGE: "05", // 用户余额改变
  LOTTERY_PUT_RIGHT: "06", // 开奖纠正错误
  VERSION_UPDATE: "07", // 版本更新
  CHATROOM_AUTH_CHANGE: "09", // 聊天室权限变更通知，如被禁言等
  FIREWORKS_EXPLODE: "11", // 其他用户中奖金额达到某个档位，会往聊天室里发，就是聊天室里的烟花爆炸消息
  CHATROOM_NOTICE: "13", // 聊天室弹窗
  CHATROOM_ALL_BANNED: "14", // 聊天室全局禁言
  GIFT_BAG_ALERT: "16", // 礼包中心达标提醒
  ROB_ZHUANG_ROOM_OTHER_USER_BETTING: "17", // 抢庄房其他用户跟单投注
  ROB_ZHUANG_ROOM_BANKER_CHANGE: "18", // 抢庄房有新的庄家
  ROB_ZHUANG_ROOM_CASH_DEPOSIT_CHANGE: "19", // 抢庄房庄家的保证金发生变更
  CHATROOM_BANNED_LEVEL: "20", // 后台修改了聊天室的禁言等级、是否开启快捷对话quickDialogue字段的通知、全局禁言时间段通知
  YUEBAO_BALANCE_CHANGE: "21", // 余额宝金额变更
  ROB_ZHUANG_ROOM_SPEAK_MODE: "22", // 抢庄房中聊天室发言模式
  MEMBER_MSG: "26", // 后台推送会员消息
  RECALL: "100", // 自定义的撤回消息
  ROB_ZHUANG_ROOM_WELCOME: "102", // 其他app发送的欢迎语
  RED_PACKET: "103", // 自定义红包消息
  ROB_ZHUANG_ROOM_AT: "104", // 抢庄房@功能
  CLEAR_SCREEN: "110", // 自定义的清屏消息
  JOIN_CHATROOM: "101", // 自定义的通知其它端口哪个用户加入了聊天室消息
  STICKY_TOPIC: "105", // 自定义的置顶消息
  GIF: "106" // 自定义的表情消息
};

export const MessageLocalStatus = (function(MessageLocalStatus) {
  MessageLocalStatus[(MessageLocalStatus["LOADING"] = "0")] = "LOADING";
  MessageLocalStatus[(MessageLocalStatus["SUCCESS"] = "1")] = "SUCCESS";
  MessageLocalStatus[(MessageLocalStatus["ERROR"] = "2")] = "ERROR";
  return MessageLocalStatus;
})({});

export const MessageEventBusTypes = {
  kMessageStore: "kMessageStore", // 所有的消息
  kChatRoomMessage: "kChatRoomMessage", // 聊天室房间消息
  kChatPrivateMessage: "kChatPrivateMessage", // 私聊房间消息
  kChatRedPacketBattleMessage: "kChatRedPacketBattleMessage", // 红包大战聊天室消息
  kChatGrabRoomMessage: "kChatGrabRoomMessage", // 抢庄房消息
  kChatUpdateConversationMessage: "kChatUpdateConversationMessage", // 更新会话列表中的会话的上一条消息
  kChatUpdateConversationUnread: "kChatUpdateConversationUnread", // 更新会话列表中的会话的未读数
  kChatUnPrivateMessage: "kChatUnPrivateMessage" // 取消绑定私聊房间消息
};

export const BannedTexts = (function(BannedTexts) {
  BannedTexts["0"] = BannedTexts["kEmpty"] = "";
  BannedTexts["1"] = BannedTexts["kLevel"] = "晋级为高段位会员就可以发言";
  BannedTexts["2"] = BannedTexts["kBanned"] = "您已被禁言，请联系客服";
  BannedTexts["3"] = BannedTexts["kAllBanned"] = "全局禁言中";
  return BannedTexts;
})({});
